module.exports = __webpack_public_path__ + "static/media/robo-logo.56edcb49.png";